import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { REGISTRATION_CONFIG, REGISTRATION_CONFIG_SUCCESS, REGISTRATION_CONFIG_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getRegistrationConfig({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { clientId, programId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/registration-config?client_id=${clientId}&program_id=${programId}`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: REGISTRATION_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: REGISTRATION_CONFIG_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: REGISTRATION_CONFIG_ERROR, payload: error });
  }
}

export function* watchRegistrationConfig() {
  yield takeEvery(REGISTRATION_CONFIG, getRegistrationConfig);
}

function* watchRegistrationConfigSaga() {
  yield all([fork(watchRegistrationConfig)]);
}

export default watchRegistrationConfigSaga;
